import { DefaultTheme } from 'styled-components'
import colors from './colors'

type Colors = keyof typeof colors

export interface ThemeProps {
    theme: DefaultTheme
}

type SizeKeys =
    | 'smaller'
    | 'small'
    | 'smallish'
    | 'medium'
    | 'large'
    | 'larger'
    | 'largest'
    | 'huge'
    | 'largerest'

type WeightKeys = 'light' | 'medium' | 'bold'

type ColorKeys =
    | 'background'
    | 'backgroundBackground'
    | 'backgroundForeground'
    | 'backgroundAlt'
    | 'backgroundAlt2'
    | 'backgroundInverted'
    | 'backgroundInvertedAlt'
    | 'text'
    | 'textAlt'
    | 'textInverted'
    | 'textHighlight'
    | 'link'
    | 'linkActive'
    | 'linkHover'
    | 'contrast'
    | 'border'
    | 'heatmap'
    | 'lineChartDefaultColor'
    | 'barChart'
    | 'ranges'
    | 'distinct'
    | 'velocity'
    | 'countries'
    | Colors

type ZIndexKeys = 'popover' | 'modal'

export const spacing =
    (multiplier = 1) =>
    ({ theme }: ThemeProps) =>
        `${theme.dimensions.spacing * multiplier}px`

export const fontSize =
    (size: SizeKeys) =>
    ({ theme }: ThemeProps) =>
        theme.typography.size[size]

export const fontWeight =
    (weight: WeightKeys) =>
    ({ theme }: ThemeProps) =>
        theme.typography.weight[weight]

export const color =
    (id: ColorKeys) =>
    ({ theme }: ThemeProps) =>
        theme.colors[id] as string

export const zIndex =
    (id: ZIndexKeys) =>
    ({ theme }: ThemeProps) =>
        theme.zIndexes[id]
